import { render } from "./NTabs.vue?vue&type=template&id=20da6ba8"
import script from "./NTabs.vue?vue&type=script&lang=js"
export * from "./NTabs.vue?vue&type=script&lang=js"

import "./NTabs.vue?vue&type=style&index=0&id=20da6ba8&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__